export const MIN_RANGE_POINTER = 'min';
export const MAX_RANGE_POINTER = 'max';
export const DRIVER_LICENCE_CAMPAIGN_TEST_ID = 'Driver_licence_campaign';
export const AVAILABLE_DRIVER_LICENCE_KEY = 'available_driver_licence';
